import TranslationKeys from "../../../contexts/I18nContext/translationKeys";
import {
  WhmBox,
  WhmTextField,
  whmTheme,
  WhmTooltip,
} from "@securitize/reactjs-whm";
import { Translate, TranslateHtml } from "../../Translation/Translate";
import { InfoCard } from "../shared/InfoCard";
import React from "react";
import { UseQueryResult } from "@tanstack/react-query";
import { InvestorDto } from "../../../data/dtos/investor.dto";
import { columnBox, textFieldTooltipBox, wrapBox } from "../shared/styles";
import { ReactComponent as InfoOutlined } from "@securitize/assets-sec-ui/dist/icons/svg/info.svg";
import { iconSmall } from "../../shared/iconThemes";
import CountryTextField from "../../shared/CountryTextField/CountryTextField";

interface TaxJurisdictionCardProps {
  investorInfoQuery: UseQueryResult<InvestorDto, Error>;
}

export const TaxJurisdictionCard: React.FC<
  React.PropsWithChildren<TaxJurisdictionCardProps>
> = ({ investorInfoQuery }) => {
  return (
    <InfoCard
      title={
        <Translate
          translationKey={
            TranslationKeys.PROFILE_PERSONAL_INFORMATION_TAX_CARD_TITLE
          }
        />
      }
      subtitle={
        <Translate
          translationKey={
            TranslationKeys.PROFILE_PERSONAL_INFORMATION_TAX_CARD_SUBTITLE
          }
        />
      }
      footer={
        <TranslateHtml
          translationKey={
            TranslationKeys.PROFILE_PERSONAL_INFORMATION_TAX_CARD_FOOTER
          }
        />
      }
    >
      <WhmBox
        component="form"
        sx={{
          ...columnBox,
          marginTop: "32px",
        }}
        noValidate
        autoComplete="off"
        gap={8}
      >
        {investorInfoQuery.data?.details.tax &&
          investorInfoQuery.data.details.tax.map((tax, index) => (
            <WhmBox
              key={index}
              sx={{
                ...wrapBox,
                gap: "16px",
              }}
            >
              <CountryTextField
                key={index}
                name={"countryCode"}
                value={tax.taxCountryCode}
                dataTestId={
                  "profile-personal-information-tax-jurisdiction-country-field"
                }
                disabled
                label={
                  <Translate
                    translationKey={
                      TranslationKeys.PROFILE_PERSONAL_INFORMATION_FIELDS_TAX_RESIDENCE
                    }
                  />
                }
              />
              <WhmBox sx={textFieldTooltipBox}>
                <WhmTextField
                  id="taxId"
                  inputProps={{
                    "data-test-id":
                      "profile-personal-information-tax-jurisdiction-tax-id-field",
                  }}
                  label={
                    <Translate
                      translationKey={
                        TranslationKeys.PROFILE_PERSONAL_INFORMATION_FIELDS_TAX_ID
                      }
                    />
                  }
                  defaultValue={tax.taxId}
                  disabled
                  sx={{ flexGrow: 1, marginRight: "8px" }}
                />
                <WhmTooltip
                  placement="top-start"
                  data-test-id="profile-personal-information-tax-jurisdiction-tooltip"
                  title={
                    <TranslateHtml
                      translationKey={
                        TranslationKeys.PROFILE_PERSONAL_INFORMATION_TAX_CARD_TOOLTIP
                      }
                    />
                  }
                >
                  <InfoOutlined
                    style={iconSmall}
                    fill={whmTheme.palette.action.active}
                  />
                </WhmTooltip>
              </WhmBox>
            </WhmBox>
          ))}
      </WhmBox>
    </InfoCard>
  );
};
